import React from "react";
import { useTranslate } from "react-admin";
import { Card, CardContent, Box, Typography } from "@material-ui/core";

export const PalletBaseCard = ({ pallet, classes, cardClassName = "", extraRows = null }) => {
	const translate = useTranslate();
	const t = (field) => translate(`tab.pallets.${field}`);

	return (
		<Card className={`${classes.palletCard} ${cardClassName}`.trim()}>
			<CardContent className={classes.palletCardContent}>
				<Box className={classes.palletRow}>
					<Typography className={classes.palletLabel}>{t("id")}</Typography>
					<Typography className={classes.palletValue}>{pallet.pallet_id}</Typography>
				</Box>
				<Box className={classes.palletRow}>
					<Typography className={classes.palletLabel}>{t("sscc")}</Typography>
					<Typography className={classes.palletValue}>{pallet.sscc || "-"}</Typography>
				</Box>
				<Box className={classes.palletRow}>
					<Typography className={classes.palletLabel}>{t("ceel_number")}</Typography>
					<Typography className={classes.palletValue}>{pallet.ceel_number || "-"}</Typography>
				</Box>
				{extraRows}
			</CardContent>
		</Card>
	);
};
